var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconProjects = function SvgIconProjects(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.32 4.82h-5q-.703.04-1.172.508T3.68 6.5v10q0 .704.468 1.172.47.468 1.172.508h13.36q.703-.04 1.172-.508t.468-1.172V8.18q0-.743-.468-1.211-.47-.47-1.172-.469H12z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconProjects);
export { ForwardRef as ReactComponent };